import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErzeugungsanlageService } from '../../../service/erzeugungsanlage/erzeugungsanlage.service';
import { inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SteuergruppeIdNetzzuordnungValidator {

    private erzeugungsanlageService = inject(ErzeugungsanlageService);

    validate(netzzuordnungId?: string, dokumentenId?: string): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            if (!!netzzuordnungId && control.value?.length == 11) {
                return this.erzeugungsanlageService.isSteuergruppeIdNetzzuordnungValid(
                    control.value,
                    netzzuordnungId,
                    dokumentenId,
                ).pipe(
                    map(isUnique => (isUnique ? null : { steuergruppeIdNetzzuordnungNotValid: true })),
                    catchError(() => {
                        console.error('Error while checking if steuergruppeId and netzzuordnung is valid');
                        return of({ steuergruppeIdNetzzuordnungNotValid: true });
                    }),
                );
            }
            return of(null);
        };
    }
}
